module.exports = __webpack_public_path__ + "img/risk-control-team.7a226715.svg";